
import React, { useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import moment from 'moment'
import { useDispatch } from 'react-redux'

import useTranslation from '@/Hooks/UseTranslation'
import { useProgrammation } from '@/Hooks/UseProgrammation'
import { useProject } from '@/Hooks/UseProject'
import { useDatePicker } from '@/Hooks/UseDatePicker'

import { updateTaskAction } from '@/Redux/Actions/ProgrammationManagerActions'
import { updateTaskBaseDates } from '@/Services/ProgrammationManagerService'

import InputText from '../../components/InputText'

const TaskBaseDates = () => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened: task, patchItemOpened, setEditingItem } = useProgrammation()
  const { project, nonWorkingDays } = useProject()

  const { showDateRangePicker, hideDatePicker } = useDatePicker()

  const [ baseStart, setBaseStart ] = useState(moment(task.baseStart || task.startsAt).format('YYYY-MM-DD'))
  const [ baseEnd, setBaseEnd ] = useState(moment(task.baseEnd || task.endsAt).format('YYYY-MM-DD'))

  const saveChanges = async (baseStart: string, baseEnd: string) => {
    setEditingItem(true)

    const [ error, data ] = await updateTaskBaseDates(task._id, baseStart, baseEnd)

    setEditingItem(false)

    if (error) {
      return false
    }

    patchItemOpened({
      baseStart: data.task.baseStart,
      baseEnd: data.task.baseEnd,
      baseDays: data.task.baseDays,
    })

    await dispatch(updateTaskAction(data.task, data.updatedTasks))
  }

  const handleChangeDates = async (dates: any) => {

    const {
      startDate,
      endDate
    } = dates

    setBaseStart(startDate)
    setBaseEnd(endDate)

    await saveChanges(startDate, endDate)

    hideDatePicker()
  }

  const handleShowDateRangePicker = () => {

    showDateRangePicker({
      startDate: baseStart,
      endDate: baseEnd,
      projectStartDate: project.startsAt,
      projectEndDate: project.endsAt,
      nonWorkingDays,
      onChangeRange: handleChangeDates
    })
  }

  return (
    <>
      <Row>
        <Col>
          <h5 className='group-title'>
            {t('PROGRAMMATION_MANAGER:BaseDatesTitleLabel')}
          </h5>
        </Col>
      </Row>
      <Row>

        <Col sm={4}>
          <Form.Group>
            <Form.Label>
              {t('PROGRAMMATION_MANAGER:BaseStartLabel')}
            </Form.Label>
            <InputText
              value={moment(baseStart).format('DD/MM/YYYY')}
              placeholder="dd/mm/yyyy"
              onClick={handleShowDateRangePicker}
              asButton
            />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group>
            <Form.Label>
              {t('PROGRAMMATION_MANAGER:BaseEndLabel')}
            </Form.Label>
            <InputText
              value={moment(baseEnd).format('DD/MM/YYYY')}
              placeholder="dd/mm/yyyy"
              onClick={handleShowDateRangePicker}
              asButton
            />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group>
            <Form.Label>
              {t('PROGRAMMATION_MANAGER:BaseDaysLabel')}
            </Form.Label>
            <InputText
              value={task.baseDays || task.executeDays}
              style={{
                padding: '0.375rem 0.75rem !important'
              }}
              disabled
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  )
}

export default TaskBaseDates
